module.exports = __webpack_public_path__ + "media/buzz.093eed4f.mp3";